import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/app/staff")({
  component: StaffLayout,
});

function StaffLayout() {
  const { profile, loading } = useAuth();
  const nav = useNavigate();

  const isStaff = profile?.role === "staff" || profile?.role === "admin";

  useEffect(() => {
    if (!loading && profile && !isStaff) {
      nav({ to: "/app/customer/dashboard" });
    }
  }, [loading, profile, isStaff, nav]);

  if (loading || !profile) return null;
  if (!isStaff) return null;

  return <Outlet />;
}
